import { create } from 'zustand';

interface UiState {
  /** Universelle Suche (Command-Palette, ⌘K / Strg+K) offen? — ADR 0015. */
  isSearchOpen: boolean;
  setSearchOpen: (open: boolean) => void;
  /** Tastenkürzel-Übersicht (Spickzettel, „?") offen? */
  isShortcutsOpen: boolean;
  setShortcutsOpen: (open: boolean) => void;
}

// Den Sidebar-Zustand verwaltet der SidebarProvider (@proerp/ui) selbst
// (Cookie-persistiert, Strg/⌘+B) — hier lebt nur noch App-weiter UI-State.
export const useUiStore = create<UiState>((set) => ({
  isSearchOpen: false,
  setSearchOpen: (open) => set({ isSearchOpen: open }),
  isShortcutsOpen: false,
  setShortcutsOpen: (open) => set({ isShortcutsOpen: open }),
}));
